import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const slug = "api";
const SupplierPurchasedServices = {
  // Define your API functions here
  getList: async (supplierId) => {
    const response = await apiService.get(
      `${slug}/stock-report/supplierpurchases?supplierId=${supplierId}`
    );
    return response.data;
  },
};

export default SupplierPurchasedServices;
